import { render, staticRenderFns } from "./TransactionsItem.vue?vue&type=template&id=0221237c&lang=pug&"
import script from "./TransactionsItem.vue?vue&type=script&lang=js&"
export * from "./TransactionsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports